import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"
import _imports_0 from '@/assets/img/searchbar/clearsearch.svg'
import _imports_1 from '@/assets/img/searchbar/Filter.svg'


const _hoisted_1 = { class: "searchbar__citypick--popup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Выберите город", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "searchbar _container" }
const _hoisted_5 = { class: "searchbar__bar" }
const _hoisted_6 = {
  key: 0,
  class: "searchbar__bar--iconsearch"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5ZM12.3266 13.2408C11.0222 14.3386 9.33833 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.08208 14.5101 10.5498 13.6738 11.7596L16.2071 14.2929C16.5976 14.6834 16.5976 15.3166 16.2071 15.7071C15.8166 16.0976 15.1834 16.0976 14.7929 15.7071L12.3266 13.2408Z",
    fill: "#667387"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "searchbar__citypick--location" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "22",
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 9C16 11.3195 14.5889 14.1248 12.6883 16.5006C11.7673 17.6518 10.8073 18.6054 10.0006 19.2508C9.5953 19.575 9.26348 19.7935 9.02351 19.9208L9 19.9331L8.97649 19.9208C8.73652 19.7935 8.4047 19.575 7.99939 19.2508C7.19266 18.6054 6.23271 17.6518 5.31174 16.5006C3.4111 14.1248 2 11.3195 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM9 22C11 22 18 15 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 15 7 22 9 22ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z",
      fill: "#1E2228"
    })
  ])
], -1)
const _hoisted_12 = { class: "searchbar__citypick--text" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

import store from '@/store'
import Popup from '../../components/Popup/Popup.vue'
import { ref, computed, onMounted, nextTick } from 'vue'
import { useBreakpoints, onClickOutside } from '@vueuse/core'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
  showLocation: Boolean,
  showFilters: Boolean,
  isHomePage: {
    type: Boolean,
    dafult: true,
  },
  isPubliced: {
    type: Boolean,
    default: true,
  },
  isAdminPage: {
    type: Boolean,
    default: false,
  },
},
  emits: ['openFilters', 'init-request'],
  setup(__props, { emit }) {

const props = __props;


const route = useRoute()
const router = useRouter()

const breakpoints = useBreakpoints({
  tablet: 640,
  deskFilters: 695.98,
})

const mobile = breakpoints.smaller('tablet')
const mobileFilters = breakpoints.smaller('deskFilters')



const oldSearch = ref('')
const searchText = ref('')
let searchTimeout = setTimeout(() => {}, 500) as ReturnType<typeof setTimeout>
const minSearchSymbol = 3
const isPickerOpen = ref(false)
const isOpen = ref(false)
const showContent = ref(false)
const citypickRef = ref(null)

const currentRoute = computed(() => route.name)
const getSorters = computed(() => store.getters.getSortItem)
const cities = computed(
  () =>
    store.getters.getCityItems &&
    store.getters.getCityItems.filter((cit) => cit.getCityId() > 0)
)
const city = computed(() => store.getters.getCityItem)

const openPopup = () => {
  let inputs = document.querySelectorAll('input')
  inputs.forEach((el) => {
    el.blur()
  })
  isOpen.value = true
}
const onInputSearchControl = (event: any) => {
  if (searchTimeout) {
    clearTimeout(searchTimeout)
  }
  searchTimeout = setTimeout(() => {
    const search: string = event.target.value

    // Устанавливаем строку поиска
    store.dispatch('setSearchCardItem', search.toLowerCase()).then(() => {
      if (currentRoute.value == 'Home' && search !== '') {
        router.push({ path: 'all', query: { text: search } })
        return
      }
      loadCardsSearch()
    })

    oldSearch.value = search
  }, 500)
}

const getFilters = () => {
  const searchCardItem = store.getters.getSearchCardItem
  const cityItem = store.getters.getCityItem
  const sbeItem = store.getters.getSbeItem
  const cardTypeItem = store.getters.getCardTypeItem
  const categoryItem = store.getters.getCategoryItem
  return {
    cardName: searchCardItem,
    cityName:
      cityItem && cityItem.getCityId() != 4 ? cityItem.getCityName() : '',
    sbeFullname:
      sbeItem && sbeItem.getSbeId() != 12 ? sbeItem.getSbeFullname() : '',
    typeName:
      cardTypeItem && cardTypeItem.getTypeId() != 1
        ? cardTypeItem.getTypeName()
        : '',
    categoryName: categoryItem ? categoryItem.getCategoryName() : '',
    cardPubliced: props.isPubliced,
  }
}

const loadCardsSearch = () => {
  store.dispatch('getCardItems', {
    filter: getFilters(),
    pagination: {
      page: 1,
      limit: 100,
    },
    sort: getSorters,
    isHomePage: props.isHomePage,
  })
}
const clearSearchControl = (isInit = false) => {
  store.dispatch('setSearchCardItem', '').then(() => {
    if (!isInit) {
      searchText.value = ''
      loadCardsSearch()
    }
  })
  searchText.value = ''
}

// Установка города
const setCity = (city) => {
  // Устанавливаем город
  store.dispatch('setCityItem', city)

  // Перезагружаем карточки
  loadCards()
}

// Загрузка городов
const loadCities = () => {
  store
    .dispatch('getCityItems', {
      filter: {
        cityName: '',
      },
      sort: {
        name: 'city_name',
        exp: 'asc',
      },
      pagination: {
        page: 1,
        limit: 100,
      },
    })
    .then(() => loadCards())
}

// Загрузка карточек
const loadCards = () => {
  store
    .dispatch('getCardItems', {
      filter: {
        cityName:
          city.value !== undefined && city.value.getCityId() != 4
            ? city.value.getCityName()
            : '',
        cardPubliced: props.isPubliced,
      },
      pagination: {
        page: 1,
        limit: 100,
      },
      sort: {
        name: props.isAdminPage ? 'created_date' : 'card_priority',
        exp: props.isAdminPage ? 'desc' : 'asc',
      },
      isHomePage: props.isHomePage,
    })
    .then(() => emit('init-request', true))
}

onMounted(() => {
  // oldSearch.value = ''

  if (cities.value) store.dispatch('setCityItem', cities.value[0])

  clearSearchControl(true) // true - не перезагружать стору таблицы

  if (route.query.text !== undefined) {
    searchText.value = route.query.text
    store.commit('setIsCardBusy', true)
    onInputSearchControl({
      target: {
        value: route.query.text,
      },
    })
  } else {
    loadCities()
  }
})
onClickOutside(citypickRef, () => {
  isPickerOpen.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "popup",
      onAfterEnter: _cache[2] || (_cache[2] = ($event: any) => (showContent.value = true))
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createBlock(Popup, {
              key: 0,
              open: isOpen.value,
              cards: false,
              mobfilters: true,
              showContent: showContent.value,
              onPopupClose: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false)),
              onCloseContent: _cache[1] || (_cache[1] = ($event: any) => (showContent.value = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cities), (cityItem) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["searchbar__citypick--city", cityItem.getCityId() == _unref(city).getCityId() ? 'active' : '']),
                      key: cityItem,
                      onClick: ($event: any) => {;[setCity(cityItem), (showContent.value = false)]}
                    }, [
                      _createElementVNode("p", null, _toDisplayString(cityItem?.getCityName() || ' '), 1)
                    ], 10, _hoisted_3))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["open", "showContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!searchText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchText).value = $event)),
          placeholder: "Найти привилегии",
          autocomplete: "off",
          maxlength: "80",
          type: "text",
          class: "searchbar__bar--input",
          onInput: _cache[4] || (_cache[4] = ($event: any) => (onInputSearchControl($event)))
        }, null, 544), [
          [_vModelText, searchText.value]
        ]),
        (searchText.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (clearSearchControl())),
              class: "searchbar__bar--iconclear"
            }, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      (__props.showLocation)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "searchbar__citypick",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(mobile) ? openPopup() : (isPickerOpen.value = !isPickerOpen.value)))
          }, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(city)?.getCityName() || ' '), 1),
            _withDirectives(_createElementVNode("div", {
              ref_key: "citypickRef",
              ref: citypickRef,
              class: "searchbar__citypick--pick"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cities), (cityItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "searchbar__citypick--city",
                  key: cityItem,
                  onClick: ($event: any) => (setCity(cityItem))
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(cityItem.getCityId() == _unref(city).getCityId() ? 'active' : '')
                  }, _toDisplayString(cityItem?.getCityName() || ' '), 3)
                ], 8, _hoisted_13))
              }), 128))
            ], 512), [
              [_vShow, isPickerOpen.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.showFilters && _unref(mobileFilters))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "searchbar__filters",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('openFilters')))
          }, _hoisted_15))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})